function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 10L9 12L13 8M5.83474 2.69705C6.55227 2.63979 7.23346 2.35763 7.78132 1.89075C9.0598 0.801229 10.9402 0.801229 12.2187 1.89075C12.7665 2.35763 13.4477 2.63979 14.1653 2.69705C15.8397 2.83067 17.1693 4.16031 17.303 5.83474C17.3602 6.55227 17.6424 7.23346 18.1093 7.78132C19.1988 9.0598 19.1988 10.9402 18.1093 12.2187C17.6424 12.7665 17.3602 13.4477 17.303 14.1653C17.1693 15.8397 15.8397 17.1693 14.1653 17.303C13.4477 17.3602 12.7665 17.6424 12.2187 18.1093C10.9402 19.1988 9.0598 19.1988 7.78132 18.1093C7.23346 17.6424 6.55227 17.3602 5.83474 17.303C4.16031 17.1693 2.83067 15.8397 2.69705 14.1653C2.63979 13.4477 2.35763 12.7665 1.89075 12.2187C0.801229 10.9402 0.801229 9.0598 1.89075 7.78132C2.35763 7.23346 2.63979 6.55227 2.69705 5.83474C2.83067 4.16031 4.16031 2.83067 5.83474 2.69705Z",
  stroke: "#19C5B4",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.7e62c1c0.svg";
export { ForwardRef as ReactComponent };